'use client';

import { EmblaCarouselType } from 'embla-carousel';
import Image from 'next/image';
import { useState } from 'react';

import type { PageBlock } from '@/payload/payload-types-block';
import { UiKitCarousel } from '@/ui-kit/carousel';

import { GiftCardDesignThumbnail } from '../GiftCardDesignThumbnail/GiftCardDesignThumbnail';

import { styles } from './DesignSelector.styles';

type GiftCardCreateDesignCard = NonNullable<
  PageBlock<'giftCardCreate'>['designCards']
>[number];

const getCardImageUrl = (card: GiftCardCreateDesignCard) =>
  typeof card.image === 'object' && card.image !== null ? card.image.url || '' : '';

export interface DesignSelectorProps {
  giftCards: PageBlock<'giftCardCreate'>['designCards'];
  selectedGiftCard: GiftCardCreateDesignCard;
  onChangeSelectedGiftCard: (giftCard: GiftCardCreateDesignCard) => void;
}

export function DesignSelector({
  giftCards,
  selectedGiftCard,
  onChangeSelectedGiftCard
}: DesignSelectorProps) {
  const slots = styles();

  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType | null>(null);

  const handleChange = (index: number) => {
    emblaApi?.scrollTo(index);
    onChangeSelectedGiftCard(giftCards[index]);
  };

  return (
    <div className={slots.base()}>
      <div className={slots.desktop()}>
        {giftCards.map((giftCard) => (
          <GiftCardDesignThumbnail
            key={giftCard.id}
            giftCard={giftCard}
            selected={selectedGiftCard.id === giftCard.id}
            onClick={() => onChangeSelectedGiftCard(giftCard)}
          />
        ))}
      </div>

      <div className={slots.mobile()}>
        <div className={slots.mobilePreview()}>
          <Image
            className={slots.mobilePreviewImage()}
            src={getCardImageUrl(selectedGiftCard)}
            alt=""
            fill
          />
        </div>
        <UiKitCarousel
          className={slots.mobileSlider()}
          loop={false}
          viewportClassName={slots.mobileSliderViewport()}
          onInit={setEmblaApi}
          dragFree
        >
          {giftCards.map((giftCard, index) => (
            <GiftCardDesignThumbnail
              key={giftCard.id}
              giftCard={giftCard}
              selected={selectedGiftCard.id === giftCard.id}
              onClick={() => handleChange(index)}
            />
          ))}
        </UiKitCarousel>
      </div>
    </div>
  );
}
